import React from "react";
import { Row, Col, Typography,Space } from "antd";
import Shipment from "./SVG/Shipment.svg";
import TradeValue from "./SVG/TradeValue.svg";



import { Container } from "./Components";
import {capitalize,nFormatter} from "utils/randomString"
const { Title, Text } = Typography;


const RowList = ({ icon, title, helpText }) => (
  <Col span={24} style={{ marginTop: 24 }}>
    <Row align="middle">
      <Space>
     <Col> {icon}</Col>

      
       <Col span={24} style={{marginLeft:'1em'}}>
       <Row>
          <Title level={5}> {title} </Title>
        </Row>
        <Row>
          <Text type="secondary">{helpText}</Text>
        </Row>
        </Col>
        </Space>
       
    </Row>
  </Col>
);

export default function TradingPartners({ data,trading_partners,overall_trade_value }) {

  //  const maxValue = trading_partners && Math.max.apply(Math, trading_partners?.map(function(o) { return o?.monetary_value; }));
  //  const trading_partner_data = trading_partners && trading_partners?.find((item) => item?.monetary_value === maxValue);

  return (
    <Container>
      <Col span={24}>
        <Row>
          <Title
            level={4}
          >{`${data?.partners} Trading partners in ${capitalize(data?.city)}`}</Title>
        </Row>
        <Row>
          <Text type="secondary">Since 2021</Text>
        </Row>

        <Row>
          <RowList
            icon={<img alt="ship" src={Shipment} width={60} />}
            title={`${data?.total_shipments} Shipments`}
            helpText={
                `This buyer has shipments worth $ ${nFormatter(data?.monetary_value,1)} from ${capitalize(data?.city)} `
            }
          />

          <RowList
            icon={<img alt="ship" src={TradeValue} width={60} />}
            title={`$ ${nFormatter(overall_trade_value,1)} worth trade`}
            helpText={`This is ${data?.percentage_overall?.toFixed(2)} % of their total shipment value.`}
          />
        </Row>
      </Col>
    </Container>
  );
}
